export const resetFeatureStores = async (): Promise<void> => {
  // The RTK Query cache is memory-only but must not outlive the session either.
  const [{ store }, { baseApi }, { resetPreferences }] = await Promise.all([
    import('@/common/redux/store'),
    import('@metadevprofile/shared/api'),
    import('@/profile/stores/preferences-slice'),
  ]);
  store.dispatch(baseApi.util.resetApiState());
  store.dispatch(resetPreferences());
};
